module.exports = __webpack_public_path__ + "static/media/diploma-bg.e9bbab3d.jpg";